export const removeUtcFormate = (date) => {
   let cleanDate = date.endsWith('Z') ? date.slice(0, -1) : date
   return cleanDate
}
